/**
 * Accessibility patches for third-party app output that we cannot edit directly.
 *
 * The Customer Fields app renders address inputs with combobox semantics
 * (role="combobox", aria-expanded, aria-autocomplete, aria-controls) even when
 * there is no live suggestions popup attached. Screen readers then announce
 * the input as an interactive combobox that doesn't behave like one, which is
 * worse than treating it as a plain text field. Strip the combobox semantics
 * so the field is announced as a regular text input.
 */
const stripComboboxSemantics = (root) => {
  const inputs = root.querySelectorAll('input[data-cf-input][role="combobox"]');
  inputs.forEach((input) => {
    input.removeAttribute('role');
    input.removeAttribute('aria-expanded');
    input.removeAttribute('aria-autocomplete');
    input.removeAttribute('aria-controls');
  });
};

const init = () => {
  stripComboboxSemantics(document);

  // The app injects its inputs after page load, so watch for late additions.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches?.('input[data-cf-input][role="combobox"]')) {
          node.removeAttribute('role');
          node.removeAttribute('aria-expanded');
          node.removeAttribute('aria-autocomplete');
          node.removeAttribute('aria-controls');
        } else {
          stripComboboxSemantics(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
